import { Divider } from '@mui/material';
import React from 'react';
import { BuildingAlternative } from '../stores/SubprojectStore.ts';
import { DecarbHubBuildingDetails } from './DecarbHubBuildingDetails.tsx';
import { DecarbHubCostSection } from './DecarbHubCostSection.tsx';
import { DecarbHubEnergySection } from './DecarbHubEnergySection.tsx';
import { DecarbHubTile } from './DecarbHubTile.ts';
import { DecarbHubTileHeader } from './DecarbHubTileHeader.tsx';

interface DecarbHubBuildingTileProps {
  usage: string;
  alternative: BuildingAlternative;
  compare?: BuildingAlternative;
  getColor: (index: number) => string;
  designLifeDisplay?: string | null;
  newOrRenewalDisplay?: string | null;
  designCost: number;
  constructionCost: number;
}

export const DecarbHubBuildingTile: React.FC<DecarbHubBuildingTileProps> = ({
  usage,
  alternative,
  compare,
  getColor,
  designLifeDisplay,
  newOrRenewalDisplay,
  designCost,
  constructionCost,
}) => {
  const annualEmissions = alternative?.tonnesCo2 || 0;
  const energyOnsiteSupply = alternative?.energyOnsiteSupply ?? {};

  return (
    <DecarbHubTile>
      <DecarbHubTileHeader usage={usage} annualEmissions={annualEmissions} />
      <DecarbHubBuildingDetails
        buildingParams={alternative?.buildingParams}
        designLifeDisplay={designLifeDisplay}
        newOrRenewalDisplay={newOrRenewalDisplay}
      />
      <Divider />
      <DecarbHubCostSection
        alternative={alternative}
        alternativeCompare={compare}
        getColor={getColor}
        designCost={designCost}
        constructionCost={constructionCost}
        annualCostLabel='Annual Energy O&M Cost'
      />
      <Divider />
      <DecarbHubEnergySection
        alternative={alternative}
        alternativeCompare={compare}
        energyDemand={alternative?.energyDemand}
        energyOnsiteSupply={energyOnsiteSupply}
        getColor={getColor}
      />
    </DecarbHubTile>
  );
};
